module.exports = __webpack_public_path__ + "img/compliance_checks-icon.c847a612.svg";